<i class="k-icon k-font-icon k-i-close dialog-close" (click)="onClose()"></i>
<div class="container-fluid">
  <div class="row">
    <div class="container">
      <div class="dialog-title">Archive Hunt</div>
      <div>
        Are you sure you want to archive <strong>{{ hunt.name }}</strong
        >?
      </div>

      <button
        themeColor="primary"
        class="dialog-button"
        size="large"
        (click)="onSubmit()"
        kendoButton
      >
        Archive
      </button>
    </div>
  </div>
</div>
